// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/get_canvases_for_filter" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementGetCanvasesForFilter } from "./constants";
import type { EngagementGetCanvasesForFilterResult, InteractionConstants } from "./types";

export const getEngagementGetCanvasesForFilter = reactQueryFetcherAdapter(
  engagementGetCanvasesForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    isCdiCanvasLookup = false,
    interaction?: InteractionConstants,
    filterKey?: string
  ): Promise<EngagementGetCanvasesForFilterResult[]> => {
    return fetch(
      "/engagement/get_canvases_for_filter",
      "GET",
      {
        app_group_id: appGroupId,
        query,
        limit,
        is_cdi_canvas_lookup: isCdiCanvasLookup,
        interaction,
        filter_key: filterKey,
      },
      { signal }
    );
  }
);
